// extracted by mini-css-extract-plugin
export default {"tx":"cbd2e8b383","line":"de71c0f3d1"};